import { render } from "./ProvisionalEntryForm.vue?vue&type=template&id=68d7a003&scoped=true"
import script from "./ProvisionalEntryForm.vue?vue&type=script&lang=js"
export * from "./ProvisionalEntryForm.vue?vue&type=script&lang=js"

import "./ProvisionalEntryForm.vue?vue&type=style&index=0&id=68d7a003&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d7a003"]])

export default __exports__